import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import type { Nullable } from '@ps/utils';
import { BuyerApi } from '../api/buyer.api';
import { BuyerSettingsPayloadMapper } from '../api/mappers/buyer-payload.mapper';
import { BillingRulesPayloadMapper } from '../api/mappers/billing-rules-payload.mapper';
import { BillingRules, BuyerSettings } from '../state/buyer-state.model';

@Injectable({ providedIn: 'root' })
export class BuyerService {
  private readonly _api = inject(BuyerApi);
  private readonly _payloadMapper = new BuyerSettingsPayloadMapper();
  private readonly _billingRulesPayloadMapper = new BillingRulesPayloadMapper();

  public getByBuyerId(buyerId: number): Observable<BuyerSettings> {
    return this._api.getByBuyerId(buyerId);
  }

  public update(cmp: number, settings: BuyerSettings): Observable<void> {
    return this._api.update(cmp, this._payloadMapper.toPayload(settings));
  }

  public getDecipherHashKeyIds(): Observable<number[]> {
    return this._api.getDecipherHashKeyIds();
  }

  public getBillingRules(): Observable<Nullable<BillingRules>> {
    return this._api.getBillingRules();
  }

  public createBillingRules(rules: BillingRules): Observable<BillingRules> {
    return this._api.createBillingRules(
      this._billingRulesPayloadMapper.toPayload(rules),
    );
  }

  public updateBillingRules(rules: BillingRules): Observable<BillingRules> {
    if (rules.id === null) {
      return throwError(
        () => new Error('Cannot update billing rules without an id'),
      );
    }
    return this._api.updateBillingRules(
      rules.id,
      this._billingRulesPayloadMapper.toPayload(rules),
    );
  }
}
